import { forwardRef, FunctionComponent } from "react";
import ModalIncluir from "../../../../../../components/modalIncluir";
import { Button, FormLabel, Grid, Input, Switch } from "@mui/material";
import InputCep from "../../../../../../components/inputs/cepInput";
import { UseServicesEvent } from "../../../context/servicesContext";
import SelectAtividadeGrupo from "../../../../../../components/selects/selectAtividadeGrupo";
import DatePicker, { registerLocale } from "react-datepicker";
import ptBR from 'date-fns/locale/pt-BR'
import { format } from 'date-fns'

import "react-datepicker/dist/react-datepicker.css"

registerLocale('ptBR', ptBR);

interface ModalCreateEventsProps {

}

export const InputDate = forwardRef(({ value, onClick }, ref) => {
  return (
    <>
      <Input
        sx={{ width: '100%' }}
        type={'datetime'}
        onClick={onClick}
        value={value}
        ref={ref} />
    </>
  )
})

const ModalCreateEvents: FunctionComponent<ModalCreateEventsProps> = () => {

  const { handleCreate, alterEvento, evento } = UseServicesEvent();

  return (<>
    <ModalIncluir>
      <>
        <div style={{
          borderBottom: '1px solid #ccc',
          padding: '8px 0',
          marginBottom: '4px'
        }}>
          <p style={{ fontSize: '16px', fontWeight: 600 }}>Criar Evento</p>
        </div>
        <Grid display={'grid'} gap={2}>

          <SelectAtividadeGrupo
            idgrupo={1}
            onChange={(event) => alterEvento('atividade', event?.target?.value)}
            value={evento?.atividade}
            getDescription={(event) => alterEvento('descricao', event)}
          />

        <Grid display={'grid'}>
          <FormLabel>Descrição</FormLabel>
          <Input
            value={evento?.descricao}
            onChange={(event) => alterEvento('descricao', event.target.value)}
          />
        </Grid>


          <Grid>
            <FormLabel>Ativo</FormLabel>
            <Switch
              defaultChecked={evento?.ativo}
              onClick={() => alterEvento('ativo', !evento?.ativo)}
            />
          </Grid>

          <Grid display={'grid'}>
            <FormLabel>Início</FormLabel>
            <DatePicker
              showTimeSelect
              locale={'ptBR'}
              dateFormat="Pp"
              minDate={new Date()}
              selected={evento?.inicioForm}
              onChange={(value) => {
                {
                  alterEvento('inicio', format(value, 'yyyy-MM-dd hh:mm'))
                  alterEvento('inicioForm', value)
                }
              }}
              customInput={
                <InputDate />
              }
            />

          </Grid>
          <Grid display={'grid'}>
            <FormLabel>Fim</FormLabel>
            <DatePicker
              showTimeSelect
              locale={'ptBR'}
              dateFormat="Pp"
              minDate={new Date()}
              selected={evento?.fimForm}
              onChange={(value) => {
                alterEvento('fim', format(value, 'yyyy-MM-dd hh:mm'))
                alterEvento('fimForm', value)
              }}
              customInput={
                <InputDate />
              }
            />
          </Grid>
          <Grid>
            <FormLabel>Permite Inscrição?</FormLabel>
            <Switch
              defaultChecked={evento?.inscricao}
              onClick={() => alterEvento('inscricao', !evento?.inscricao)}
            />
          </Grid>
          <Grid display={'grid'}>
            <FormLabel>Whatsapp</FormLabel>
            <Input onChange={(event) => alterEvento('whatsapp', event?.target?.value)} />
          </Grid>
          <Grid display={'grid'}>
            <InputCep
              check
              onChange={(value) => alterEvento('cep', value)}
              value={evento?.cep} />
          </Grid>
        </Grid>
        <div>
          <Button
            sx={{
              width: '100%',
              mt: 1
            }}
            color="success"
            onClick={handleCreate}
            variant="contained"
          >
            Criar
          </Button>
        </div>
      </>
    </ModalIncluir>
  </>);
}

export default ModalCreateEvents;
